const Footer = () => {
    return (
        <footer className="w-full bg-card border-t border-border text-foreground">
            <div className="max-w-6xl mx-auto px-6 py-16">
                <div className="grid md:grid-cols-4 gap-8 mb-8">
                    {/* Brand */}
                    <div>
                        <h3 className="text-primary font-bold text-lg mb-4">ProjectX</h3>
                        <p className="text-sm text-foreground/70">
                            Hozz létre lenyűgöző projekteket velünk.
                        </p>
                    </div>

                    {/* Product */}
                    <div>
                        <h4 className="text-primary font-semibold mb-4">Termék</h4>
                        <ul className="space-y-2 text-sm">
                            <li><a href="#" className="text-foreground/70 hover:text-primary transition-colors">Tervek</a></li>
                            <li><a href="#" className="text-foreground/70 hover:text-primary transition-colors">Funkciók</a></li>
                            <li><a href="#" className="text-foreground/70 hover:text-primary transition-colors">Biztonsági</a></li>
                            <li><a href="#" className="text-foreground/70 hover:text-primary transition-colors">Hírlevelek</a></li>
                        </ul>
                    </div>

                    {/* Company */}
                    <div>
                        <h4 className="text-primary font-semibold mb-4">Vállalat</h4>
                        <ul className="space-y-2 text-sm">
                            <li><a href="#" className="text-foreground/70 hover:text-primary transition-colors">Rólunk</a></li>
                            <li><a href="#" className="text-foreground/70 hover:text-primary transition-colors">Blog</a></li>
                            <li><a href="#" className="text-foreground/70 hover:text-primary transition-colors">Karrier</a></li>
                            <li><a href="#" className="text-foreground/70 hover:text-primary transition-colors">Sajtó</a></li>
                        </ul>
                    </div>

                    {/* Legal */}
                    <div>
                        <h4 className="text-primary font-semibold mb-4">Jogi</h4>
                        <ul className="space-y-2 text-sm">
                            <li><a href="#" className="text-foreground/70 hover:text-primary transition-colors">Adatvédelem</a></li>
                            <li><a href="#" className="text-foreground/70 hover:text-primary transition-colors">Feltételek</a></li>
                            <li><a href="#" className="text-foreground/70 hover:text-primary transition-colors">Cookie-k</a></li>
                            <li><a href="#" className="text-foreground/70 hover:text-primary transition-colors">Licenc</a></li>
                        </ul>
                    </div>
                </div>

                {/* Divider */}
                <div className="border-t border-border py-8">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <p className="text-sm text-foreground/70 mb-4 md:mb-0">
                            © {new Date().getFullYear()} ProjectX. Minden jog fenntartva.
                        </p>

                        {/* Social Links */}
                        <div className="flex gap-4">
                            <a href="#" className="text-foreground/70 hover:text-primary transition-colors">
                                GitHub
                            </a>
                            <a href="#" className="text-foreground/70 hover:text-primary transition-colors">
                                LinkedIn
                            </a>
                            <a href="#" className="text-foreground/70 hover:text-primary transition-colors">
                                Twitter
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
